module.exports = __webpack_public_path__ + "static/img/1051_small.9bd3e9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1051_small.png
// module id = 6Tb9
// module chunks = 1